"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* A bunch of utils. Some might be unused */
var buffer_1 = require("buffer");
var jconv_1 = __importDefault(require("jconv"));
function sleep(msec) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, msec); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.sleep = sleep;
function withTimeout(timeoutInMs, cb) {
    var _this = this;
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var timer, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    timer = setTimeout(function () {
                        reject(new Error("Operation timed out"));
                    }, timeoutInMs);
                    return [4 /*yield*/, cb()];
                case 1:
                    result = _a.sent();
                    clearTimeout(timer);
                    resolve(result);
                    return [2 /*return*/];
            }
        });
    }); });
}
exports.withTimeout = withTimeout;
function assert(condition, message) {
    if (condition) {
        return;
    }
    message = message || 'no message provided';
    throw new Error("Assertion failed: " + message);
}
exports.assert = assert;
function assertBigInt(value, message) {
    if (typeof value === 'bigint') {
        return value;
    }
    throw assert(false, "Expected BigInt type - " + message);
}
exports.assertBigInt = assertBigInt;
function assertNumber(value, message) {
    if (typeof value === 'number') {
        return value;
    }
    throw assert(false, "Expected number type - " + message);
}
exports.assertNumber = assertNumber;
function assertString(value, message) {
    if (typeof value === 'string') {
        return value;
    }
    throw assert(false, "Expected string type - " + message);
}
exports.assertString = assertString;
function assertUint8Array(value, message) {
    if (value instanceof Uint8Array) {
        return value;
    }
    throw assert(false, "Expected Uint8Array type - " + message);
}
exports.assertUint8Array = assertUint8Array;
function stringToCharCodeArray(str) {
    var result = new Array(str.length);
    for (var i = 0; i < str.length; i++) {
        result[i] = str.charCodeAt(i);
    }
    return result;
}
exports.stringToCharCodeArray = stringToCharCodeArray;
// compare ArrayBuffers
function arrayBuffersAreEqual(a, b) {
    return dataViewsAreEqual(new DataView(a), new DataView(b));
}
exports.arrayBuffersAreEqual = arrayBuffersAreEqual;
// compare DataViews
function dataViewsAreEqual(a, b) {
    if (a.byteLength !== b.byteLength)
        return false;
    for (var i = 0; i < a.byteLength; i++) {
        if (a.getUint8(i) !== b.getUint8(i))
            return false;
    }
    return true;
}
exports.dataViewsAreEqual = dataViewsAreEqual;
// Thanks to https://gist.github.com/TooTallNate/4750953
function isBigEndian() {
    return new Uint8Array(new Uint32Array([0x12345678]).buffer)[0] === 0x12;
}
exports.isBigEndian = isBigEndian;
function hexEncode(str) {
    var hex;
    var result = '';
    for (var i = 0; i < str.length; i++) {
        hex = str.charCodeAt(i).toString(16);
        result += ('0' + hex).slice(-2);
    }
    return result;
}
exports.hexEncode = hexEncode;
function arrayBufferToBinaryString(ab) {
    var src = new Uint8Array(ab);
    return uint8arrayToBinaryString(src);
}
exports.arrayBufferToBinaryString = arrayBufferToBinaryString;
function uint8arrayToBinaryString(u8a) {
    var dst = Array(u8a.length);
    u8a.forEach(function (c, i) { return (dst[i] = String.fromCharCode(c)); });
    return dst.join('');
}
exports.uint8arrayToBinaryString = uint8arrayToBinaryString;
function concatUint8Arrays() {
    var e_1, _a, e_2, _b;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var totalLength = 0;
    try {
        for (var args_1 = __values(args), args_1_1 = args_1.next(); !args_1_1.done; args_1_1 = args_1.next()) {
            var a = args_1_1.value;
            totalLength += a.length;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (args_1_1 && !args_1_1.done && (_a = args_1.return)) _a.call(args_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var res = new Uint8Array(totalLength);
    var offset = 0;
    try {
        for (var args_2 = __values(args), args_2_1 = args_2.next(); !args_2_1.done; args_2_1 = args_2.next()) {
            var a = args_2_1.value;
            res.set(a, offset);
            offset += a.length;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (args_2_1 && !args_2_1.done && (_b = args_2.return)) _b.call(args_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return res;
}
exports.concatUint8Arrays = concatUint8Arrays;
function concatArrayBuffers(buffer1, buffer2) {
    var tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
    tmp.set(new Uint8Array(buffer1), 0);
    tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
    return tmp.buffer;
}
exports.concatArrayBuffers = concatArrayBuffers;
// Thanks to: https://gist.github.com/artjomb/7ef1ee574a411ba0dd1933c1ef4690d1
function wordToByteArray(word, length) {
    var ba = [], xFF = 0xff;
    if (length > 0)
        ba.push(word >>> 24);
    if (length > 1)
        ba.push((word >>> 16) & xFF);
    if (length > 2)
        ba.push((word >>> 8) & xFF);
    if (length > 3)
        ba.push(word & xFF);
    return ba;
}
function wordArrayToByteArray(wordArray, length) {
    if (length === void 0) { length = wordArray.sigBytes; }
    var res = new Uint8Array(length);
    var bytes;
    var i = 0;
    var offset = 0;
    while (length > 0) {
        bytes = wordToByteArray(wordArray.words[i], Math.min(4, length));
        res.set(bytes, offset);
        length -= bytes.length;
        offset += bytes.length;
        i++;
    }
    return res;
}
exports.wordArrayToByteArray = wordArrayToByteArray;
function timeToFrames(time) {
    assert(time.length === 4);
    return ((time[0] * 60 + time[1]) * 60 + time[2]) * 512 + time[3];
}
exports.timeToFrames = timeToFrames;
function pad(str, pad) {
    return (pad + str).slice(-pad.length);
}
exports.pad = pad;
function formatTimeFromFrames(value, frames) {
    if (frames === void 0) { frames = true; }
    var f = value % 512;
    value = (value - f) / 512; // sec
    var s = value % 60;
    value = (value - s) / 60; // min
    var m = value % 60;
    value = (value - m) / 60; // hour
    var h = value;
    return pad(h, '00') + ":" + pad(m, '00') + ":" + pad(s, '00') + (frames ? "+" + pad(f, '000') : "");
}
exports.formatTimeFromFrames = formatTimeFromFrames;
function halfWidthToFullWidthRange(range) {
    var mappings = {
        '0': '０',
        '1': '１',
        '2': '２',
        '3': '３',
        '4': '４',
        '5': '５',
        '6': '６',
        '7': '７',
        '8': '８',
        '9': '９',
        '-': '－',
        '/': '／',
        ';': '；',
    };
    return range
        .split('')
        .map(function (n) { var _a; return _a = mappings[n], (_a !== null && _a !== void 0 ? _a : ''); })
        .join('');
}
exports.halfWidthToFullWidthRange = halfWidthToFullWidthRange;
function sanitizeTrackTitle(title) {
    return encodeURIComponent(title);
}
exports.sanitizeTrackTitle = sanitizeTrackTitle;
function encodeToSJIS(utf8String) {
    return jconv_1.default.encode(utf8String, 'SJIS');
}
exports.encodeToSJIS = encodeToSJIS;
function decodeFromSJIS(sjisBuffer) {
    return jconv_1.default.decode(buffer_1.Buffer.from(sjisBuffer), 'SJIS');
}
exports.decodeFromSJIS = decodeFromSJIS;
function getLengthAfterEncodingToSJIS(utf8String) {
    return encodeToSJIS(utf8String).length;
}
exports.getLengthAfterEncodingToSJIS = getLengthAfterEncodingToSJIS;
//# sourceMappingURL=utils.js.map